import * as React from 'react';
import {TextArea} from '@sail/ui';
import {EXAMPLE_TEXT} from './common';

export const Invalid = () => (
  <TextArea label="Favorite word" defaultValue={EXAMPLE_TEXT} invalid />
);
